import Loadable, { NullLoader } from '@comeon/loadable';
import { useSelector } from 'react-redux';
import { LICENSE_DEGA, LICENSE_KSA, LICENSE_SGA } from '~/utils/license-utils.js';
import { selectLicense } from '~/components/brand/ducks/selectors.js';
import useConfiguration from '~/configuration/use-configuration';

const RealityCheck = Loadable({
	loader: () => import('./reality-check.js'),
	loading: NullLoader
});

const RealityCheckGerman = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "dega-bundle" */
			'./reality-check-german.js'
		),
	loading: NullLoader
});

const NewRealityCheckGerman = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "dega-bundle" */
			'~/components/account/reality-check-new/jurisdictions/DEGA/reality-check-german'
		),
	loading: NullLoader
});

const RealityCheckNetherlands = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "ksa-bundle" */
			'./reality-check-netherlands.tsx'
		),
	loading: NullLoader
});

const NewRealityCheckNetherlands = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "ksa-bundle" */
			'~/components/account/reality-check-new/jurisdictions/KSA/reality-check-netherlands'
		),
	loading: NullLoader
});

const NewRealityCheckSweden = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sga-bundle" */
			'~/components/account/reality-check-new/jurisdictions/SGA/reality-check-sweden'
		),
	loading: NullLoader
});

const newRealityCheckROW = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "reality-check-new-default" */
			'~/components/account/reality-check-new/jurisdictions/default/reality-check-ROW'
		),
	loading: NullLoader
});

const REALITY_CHECK_IMPL = {
	[LICENSE_DEGA]: RealityCheckGerman,
	[LICENSE_KSA]: RealityCheckNetherlands
};

const NEW_REALITY_CHECK_IMPL = {
	[LICENSE_KSA]: NewRealityCheckNetherlands,
	[LICENSE_DEGA]: NewRealityCheckGerman,
	[LICENSE_SGA]: NewRealityCheckSweden
};

const RealityCheckContainer = () => {
	const license = useSelector(selectLicense);
	const { useNewRealityCheck } = useConfiguration();
	const Component = useNewRealityCheck
		? (NEW_REALITY_CHECK_IMPL[license] ?? newRealityCheckROW)
		: (REALITY_CHECK_IMPL[license] ?? RealityCheck);
	return <Component />;
};

export default RealityCheckContainer;
